/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Rasmus Sejer Lind
 Modified by:
 Client name: Danske Regioner
 Date of creation: may 30, 2023
 */



 window.initMap = function(){};
 (function ($, dis) { // jshint ignore:line
     "use strict";
 
    // var SearchBtn = document.querySelector(".search-header");
    var SearchBtnClose = document.querySelector(".close-wrapper .close-wrapper-div");
    var SearchInputWrapper = document.querySelector(".page-header-search");
    var pageHeader = document.querySelector(".page-header__main");
    var SearchInput = document.querySelector("#main-search-input-header");
    // var SearchWrapper = document.querySelector(".main-search");

    function SearchShow() {
        SearchInputWrapper.classList.toggle("search-show");
        pageHeader.classList.toggle("page-header-search-show");
        // SearchWrapper.classList.toggle("search-header-close-active");
        SearchInput.focus();
    }

    // SearchBtn.addEventListener("click", SearchShow);   
    SearchBtnClose.addEventListener("click", SearchShow);   

    var sidebar = document.querySelector(".searchpage-results");
    var articles = document.querySelector(".articles-list__filters");


    if(sidebar) {
        var PaginatonActive = document.querySelector(".searchpage__results__lists__paging .active span").innerHTML;
        var pagelistitems = document.querySelectorAll(".searchpage__results__lists__paging .pagelistitem").length;
        
        var PaginatonNumber = Number(PaginatonActive);
        var PaginatonNumberUnderCalOne = PaginatonNumber - 1;
        var PaginatonNumberUnderCalTwo = PaginatonNumber - 2;
        var PaginatonNumberUnderCalThree = PaginatonNumber - 3;
        var PaginatonNumberUnderCalFour = PaginatonNumber - 4;
        var PaginatonNumberOverCalOne = PaginatonNumber + 1;
        var PaginatonNumberOverCalTwo = PaginatonNumber + 2;
        var PaginatonNumberOverCalThree = PaginatonNumber + 3;
        var PaginatonNumberOverCalFour = PaginatonNumber + 4;
    
        if (pagelistitems >= 5) {
            if(PaginatonNumber === 1) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalThree).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalFour).classList.add("showPageNubmer");
            }
            if(PaginatonNumber === 2) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalThree).classList.add("showPageNubmer");
            }
            if(PaginatonNumber > 2) {
                if(PaginatonNumber === pagelistitems - 1) {
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalThree).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                }
                if(PaginatonNumber === pagelistitems) {
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalThree).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalFour).classList.add("showPageNubmer");
                }
                else {
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                    document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
                }
            }
        } else if(pagelistitems === 4) {
            if(PaginatonNumber === 1) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalThree).classList.add("showPageNubmer");
            }  
            if(PaginatonNumber === 2) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
            }
            if(PaginatonNumber === 3) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
            }
            if(PaginatonNumber === 4) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalThree).classList.add("showPageNubmer");
            }
        } else if(pagelistitems === 3) {
            if(PaginatonNumber === 1) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalTwo).classList.add("showPageNubmer");
            }  
            if(PaginatonNumber === 2) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
            }  
            if(PaginatonNumber === 3) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalTwo).classList.add("showPageNubmer");
            }  
        } else if(pagelistitems === 2) {
            if(PaginatonNumber === 1) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberOverCalOne).classList.add("showPageNubmer");
            } 
            if(PaginatonNumber === 2) {
                document.querySelector(".searchpage__results__lists__paging .page" + PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
            } 
        } else {
            console.log("1");
        }

        var searchPageheader = document.querySelector(".searchpage-content__header").offsetHeight;

        sidebar.style.marginTop = searchPageheader + "px";
    
    }

    if(articles) {
        var PaginatonActive = document.querySelector(".articles-list__articles__paging-bottom .active span").innerHTML;
        var pagelistitems = document.querySelectorAll(".articles-list__articles__paging-bottom .pagelistitem").length;
        var PaginatonNumber = Number(PaginatonActive);
        var PaginatonNumberUnderCalOne = PaginatonNumber - 1;
        var PaginatonNumberUnderCalTwo = PaginatonNumber - 2;
        var PaginatonNumberUnderCalThree = PaginatonNumber - 3;
        var PaginatonNumberUnderCalFour = PaginatonNumber - 4;
        var PaginatonNumberOverCalOne = PaginatonNumber + 1;
        var PaginatonNumberOverCalTwo = PaginatonNumber + 2;
        var PaginatonNumberOverCalThree = PaginatonNumber + 3;
        var PaginatonNumberOverCalFour = PaginatonNumber + 4;
    
        // if (pagelistitems >= 5) {
        //     if(PaginatonNumber === 1) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalThree+  "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalFour + "]").classList.add("showPageNubmer");
        //     }
        //     if(PaginatonNumber === 2) {
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalThree + "]").classList.add("showPageNubmer");
        //     }
        //     if(PaginatonNumber > 2) {
        //         if(PaginatonNumber === pagelistitems - 1) {
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalThree + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         }
        //         if(PaginatonNumber === pagelistitems) {
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalThree + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalFour + "]").classList.add("showPageNubmer");
        //         }
        //         else {
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //             document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //         }
        //     }
        // } else if(pagelistitems === 4) {
        //     if(PaginatonNumber === 1) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalThree + "]").classList.add("showPageNubmer");
        //     }  
        //     if(PaginatonNumber === 2) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //     }
        //     if(PaginatonNumber === 3) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //     }
        //     if(PaginatonNumber === 4) {
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalThree + "]").classList.add("showPageNubmer");
        //     }
        // } else if(pagelistitems === 3) {
        //     if(PaginatonNumber === 1) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalTwo + "]").classList.add("showPageNubmer");
        //     }  
        //     if(PaginatonNumber === 2) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //     }  
        //     if(PaginatonNumber === 3) {
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalTwo + "]").classList.add("showPageNubmer");
        //     }  
        // } else if(pagelistitems === 2) {
        //     if(PaginatonNumber === 1) {
        //         document.querySelector("[data-page=" + PaginatonNumberOverCalOne + "]").classList.add("showPageNubmer");
        //     } 
        //     if(PaginatonNumber === 2) {
        //         // document.querySelector('.articles-list__articles__paging-bottom .page + PaginatonNumberUnderCalOne +').classList.add("showPageNubmer");
        //         console.log(PaginatonNumberUnderCalOne);
        //         // document.querySelector(".articles-list__articles__paging-bottom .page " PaginatonNumberUnderCalOne).classList.add("showPageNubmer");
        //         document.querySelector("[data-page=" + PaginatonNumberUnderCalOne + "]").classList.add("showPageNubmer");
        //     } 
        // } else {
        //     console.log("1");
        // }

    
    }



  
 }(jQuery, dis));